import * as Sentry from '@sentry/react'

import { googleAudiencesResponseSchema } from './schemas'

// Same lenient-parse-with-Sentry-capture convention as
// domain/integrationAssets/mappers.js / domain/googleConversionGoals/mappers.js
// — fall through to the raw response on schema mismatch rather than breaking
// the selector.
export function mapGoogleAudiencesResponse(data) {
  const parsed = googleAudiencesResponseSchema.safeParse(data)
  if (!parsed.success) {
    Sentry.captureException(parsed.error)
  }
  const items = parsed.success ? parsed.data : Array.isArray(data) ? data : []

  return items.map((item) => ({
    id: item.id,
    resource_name: item.resource_name,
    name: item.name,
    type: item.type ?? null,
    audience_type: item.audience_type,
    size_for_display: item.size_for_display ?? null,
  }))
}

// GOOGLE_TC_TARGETING_SCHEMA.audience_resource_names (DEMAND_GEN-only) wants
// bare resource-name strings, not the rich {resource_name, id, name, ...}
// shape audiences/excluded_audiences use — flatten type=saved results here
// rather than at every call site.
export function toAudienceResourceNames(items) {
  return items.map((item) => item.resource_name).filter(Boolean)
}
